import { useState } from "react";
import { useDispatch } from "react-redux";
import { exportToCSV } from "../../helpers/utils";
import { Spinner } from "react-bootstrap";
import { endAndGenerateWinner, openContestParticipantModel } from "../../store/slices/contestSlice";
import { exportPollParticipants } from "../../store/slices/pollSlice";

const AnswerCell = ({ answerIndex, answer, totalVotesCount, contest }) => {
    let range = answer.attributes.votesCount ? Math.round((answer.attributes.votesCount / totalVotesCount) * 100) : 0;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isWinnerGenerating, setIsWinnerGenerating] = useState(false);
    const stopped = contest.attributes.state == 2 || contest.attributes.state == 3;
    const isWinnerGenerated = contest.attributes.meta?.winners?.length ? true : false;

    const exportUsers = (answerId) => {
        setIsLoading(true);
        dispatch(exportPollParticipants({ id: answerId }))
            .unwrap()
            .then(response => exportToCSV(response, `Users_${answer.attributes.title}_Answer${answerIndex + 1}`))
            .finally(() => setIsLoading(false));
    };

    const openModel = (answerId) => {
        dispatch(openContestParticipantModel({ id: null, pollId: answerId }));
    }

    const endContest = (answerId) => {
        setIsWinnerGenerating(true);
        dispatch(endAndGenerateWinner({ id: contest.id, answerId: answerId }))
            .unwrap()
            .finally(() => setIsWinnerGenerating(false));
    }


    return (
        <div className="answer-div">
            <div className="answer-row">
                <div className="mb-1">
                    <div className="answer-heading">
                        Answer {answerIndex + 1}.
                    </div>
                    <div className="answer-inner-section">
                        <div className="rangeDiv" style={{ width: `${range}%` }}></div>
                        <div className="div1">
                            <div className="text-wrap">{answer.attributes.title}</div>
                            <div> {range}% <span className='f-10'>({answer.attributes.votesCount ?? 0} votes) </span></div>
                        </div>
                    </div>
                    <div className='export-div mt-2'>
                        <button
                            className='btn btn-sm f-11 btn-dark py-1'
                            onClick={() => exportUsers(answer?.id)}
                            disabled={(isLoading || answer.attributes.votesCount == 0) ? true : false} // Disable while loading
                        >
                            {isLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-1" /> Exporting...
                                </>
                            ) : "Export Users"}
                        </button>
                    </div>
                </div>
            </div>
            <div className='ml-3 d-flex gap-1'>
                {!isWinnerGenerated && answer.attributes.votesCount > 0 && <button className='btn btn-sm f-11 btn-success py-1'
                    disabled={(!stopped) ? true : false}
                    onClick={() => {
                        endContest(answer?.id);
                    }}>{isWinnerGenerating ? (
                        <span className="d-flex gap-1">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Winner
                        </span>
                    ) : 'Winner'}</button>}

                <button className='btn btn-sm f-11 btn-primary py-1'
                    disabled={(answer.attributes.votesCount == 0) ? true : false}
                    onClick={() => {
                        openModel(answer?.id);
                    }}>Participant(s)</button>
            </div>
        </div>
    );
};

export default AnswerCell;
